<template>
  <d-container fluid class="px-3 main-content-container">
    <d-form>
      <d-form-row>
        <!-- Representatives -->
        <d-col sm="10" class="form-group">
          <label for="name">
            Representantes
          </label>
          <autocomplete
            ref="representative"
            placeholder="Representante"
            item-show="name"
            :items="list"
            :on-input="onInput"
            :on-select="setRepresentative"
          ></autocomplete>
        </d-col>
        <d-col sm="2" class="form-group">
          <label class="pt-4 d-block"></label>
          <d-button size="sm" class="d-inline btn-success" @click.prevent="attachRepresentatives()">
            Adicionar
          </d-button>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-list-group flush class="list-group-small col-10">
          <d-list-group-item v-for="(representative, index) in model" :key="index" class="py-2 pr-0 d-flex">
            <d-row class="w-100 align-items-center">
              <d-col cols="5">{{ representative.name }}</d-col>
              <d-col cols="5">{{ representative.email }}</d-col>
              <d-col cols="2 pr-0 text-right">
                <d-button size="sm" class="btn-danger" @click.prevent="detachRepresentatives(representative)">Delete</d-button>
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-form-row>
    </d-form>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Autocomplete from '_shared/Autocomplete.vue';
import ResellerService from '_services/rest/modules/reseller';
import RepresentativeService from '_services/rest/modules/representative';

export default {
  name: 'reseller-representatives',
  components: {
    Autocomplete,
  },
  props: {
    model: {
      type: Array,
      default: () => [],
    },
    resellerId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      list: [],
      representative: {
        id: null,
        name: null,
        email: null,
      },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    attachRepresentatives() {
      if (this.resellerId) {
        ResellerService.attachResellerRepresentatives(this.resellerId, this.representative.id)
          .then(response => {
            this.success(response, 'Representante salvo com sucesso');
            this.$refs.representative.$refs.input.value = null;
            this.representative.id = null;
            this.representative.name = null;
            this.representative.email = null;
          })
          .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }));
      } else {
        this.model.push(this.representative);
      }
    },
    detachRepresentatives(representative) {
      ResellerService.detachResellerRepresentatives(this.resellerId, representative.id)
        .then(response => {
          this.success(response, 'Representante removido com sucesso');
        });
    },
    saveRepresentatives(representative) {
      this.representative.email = representative.email;
    },
    success(response, message) {
      this.$emit('updateRepresentatives', response.representatives);
      this.model = response.representatives;
      this.activeAlert({ message, theme: 'success' });
    },
    onInput(search) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        const params = {
          search,
          skip: 0,
          take: 10,
        };
        RepresentativeService.getList(params)
          .then(response => {
            this.list = response.list;
          });
      }, 500);
    },
    setRepresentative(representative) {
      this.representative = representative;
    },
  },
  mounted() {
    // Events.$on(_SAVE_MODEL_, representative => {
    //   this.saveRepresentatives(representative);
    //   this.attachRepresentatives();
    // });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
</style>
